import { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { AiOutlineBank } from '@react-icons/all-files/ai/AiOutlineBank';

interface CarrierIconProps {
  slug?: string;
  className?: string;
  src?: string;
  customImage?: ReactNode;
}

export function CarrierIcon(props: CarrierIconProps) {
  const [showPlaceholder, setShowPlaceholder] = useState(!props.src);
  return showPlaceholder || !props.src ? (
    <div
      className={classNames('bg-gray-300 rounded-md p-1.5', props.className)}
    >
      <AiOutlineBank size={28} className="text-gray-100" />
    </div>
  ) : (
    <CarrierLogo {...props} setShowPlaceholder={setShowPlaceholder} />
  );
}

export function CarrierLogo(
  props: CarrierIconProps & {
    setShowPlaceholder: (showPlaceholder: boolean) => void;
  },
) {
  return (
    <>
      {props.customImage ? (
        props.customImage
      ) : (
        <img
          onError={() => props.setShowPlaceholder(true)}
          className={classNames('rounded-md shadow h-10 w-10', props.className)}
          src={props.src}
          alt={props.slug}
        />
      )}
    </>
  );
}
